import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  type FilterSuggestionsRequest,
  type FilterSuggestionsResponse,
  fetchFilterSuggestions,
} from '../../lib/api/filterSuggestions';
import { LONG_STALE_TIME } from '../../lib/queryClient';

export enum FILTER_SUGGESTIONS_API_TAGS {
  SearchSuggestions = 'SearchSuggestions',
}

export function useFilterSuggestionsQuery(body: FilterSuggestionsRequest, options?: { enabled?: boolean }) {
  return useQuery<FilterSuggestionsResponse>({
    queryKey: [FILTER_SUGGESTIONS_API_TAGS.SearchSuggestions, body],
    queryFn: () => fetchFilterSuggestions(body),
    enabled: options?.enabled ?? true,
    staleTime: LONG_STALE_TIME,
    placeholderData: keepPreviousData,
  });
}
